import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const ProtectedPage = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("isAuthenticated") !== "true") {
      navigate("/");
    }
  }, [navigate]);

  return children;
};

export default ProtectedPage;
